import { useState } from 'react';
import { useNavigate } from 'react-router';
import { App } from 'antd';
import { useTranslation } from 'react-i18next';
import { resolveScanResult } from '../app/scan';

// Top-bar scan box (mockup #scanBox): Enter resolves the code exactly like a wedge scan; marked data-scan-input so useGlobalScan ignores it.
export function ScanBox() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { message } = App.useApp();
  const [value, setValue] = useState('');

  const submit = async () => {
    const code = value.trim().toUpperCase();
    if (!code) return;
    setValue('');
    const hit = await resolveScanResult(code);
    await nav(hit.route);
    if (hit.found) void message.info(t('scan.scanned', { code }));
    else void message.warning(t('scan.notFound', { code }));
  };

  return (
    <div className="scan" title={t('topbar.scanTitle')}>
      <span aria-hidden="true">⌕</span>
      <input
        id="scanBox"
        data-scan-input
        aria-label={t('scan.placeholder')}
        placeholder={t('scan.placeholder')}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            void submit();
          }
        }}
      />
    </div>
  );
}
